import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";

export const useMyPage = () => {
  const dispatch = useDispatch();
  const { navigateToTopPage } = useNavigation();

  const handleLogout = useCallback(() => {
    dispatch(
      appActions.showModal.started({
        title: "ログアウトしますか？",
        closeButtonLabel: "閉じる",
        nextButtonLabel: "ログアウト",
        handleClose: () => dispatch(appActions.closeModal()),
        handleNext: () => {
          dispatch(
            authActions.logout.started({
              onSuccess: () => {
                navigateToTopPage();
                setTimeout(() => {
                  dispatch(
                    appActions.showModal.started({
                      title: "ログアウトしました",
                      nextButtonLabel: "閉じる",
                      handleNext: () => dispatch(appActions.closeModal()),
                    }),
                  );
                }, 100);
              },
            }),
          );
          dispatch(appActions.closeModal());
        },
      }),
    );
  }, []);

  return { handleLogout };
};
